import React, { Component } from "react";
import SearchField from "../../../Components/common/SearchField";
import { connect } from "react-redux";
import isEqual from "react-fast-compare";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { checkPrivileges, errorHandler } from "../../../Helpers";
import ConfirmDialoag from "../../../Components/common/ConfirmDialoag";
import Style from "style-it";
import Scrollbar from "react-scrollbars-custom";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../Loader";
import { removedComputedAttribute } from "../../../Actions/ComputedAttributes";
import {notifySuccess } from "../../../Utils/CustomNotifcations";
import { IconButton } from "@mui/material";
import instance from "../../../axios";
import withTranslationWrapper from "../../../HOC/withTranslation";
class Parameters extends Component {
  constructor(props) {
    super(props);
    this.state = { searchRecently: "" };
  }

  search(e) {
    this.props.searchItems(e.target.value);
  }

  render() {
    const {
      computedAttributes,
      translate,
      closeCreateFrom,
      editParameterForm,
    } = this.props;
    let parameter1 = computedAttributes.map((g) => {
      if (g.category === 0) {
        return (
          <ListRow
            key={g.id}
            item={g}
            editParameterForm={editParameterForm}
            closeCreateFrom={closeCreateFrom}
            translate={translate}
          />
        );
      }
      return null;
    });

    return (
      <Style>
        {`
					.material-icons {vertical-align: middle; color: inherit}
				`}

        <div className="fms-sidebar sidebar-bg-layer">
          {checkPrivileges("attribute") && (
            <div>
              <div className="section-head section-head-filter">
                <ul className="filter-row">
                  <li>
                    <SearchField
                      label={this.props.translate("sharedSearch")}
                      fullWidth
                      onChange={(e) => this.search(e)}
                    />
                  </li>
                  <li style={{ paddingLeft: 10, flex: 0.01 }}>
                    {checkPrivileges("attributeCreate") && (
                      <IconButton onClick={(e) => this.props.openCreateFrom()}>
                        <AddIcon />
                      </IconButton>
                    )}
                  </li>
                </ul>
              </div>
              <ul className="list-view with-padding-right sidebar-devices-list">
                <Scrollbar
                  disableTracksWidthCompensation
                  scrollerProps={{
                    renderer: (props) => {
                      const { elementRef, ...restProps } = props;
                      return (
                        <div
                          {...restProps}
                          ref={elementRef}
                          id="scrollableDiv"
                        />
                      );
                    },
                  }}
                >
                  {this.props.itemPagination ? (
                    <InfiniteScroll
                      dataLength={this.props.itemPagination.items.length}
                      next={this.props.fetchMoreItems}
                      hasMore={this.props.itemPagination.hasNext}
                      loader={<Loader defaultStyle={true} imgSize={50} />}
                      scrollableTarget="scrollableDiv"
                      endMessage={this.props.endMessage}
                    >
                      {parameter1}
                    </InfiniteScroll>
                  ) : null}
                </Scrollbar>
              </ul>
            </div>
          )}
        </div>
      </Style>
    );
  }
}

class ListRow1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onDeleteConfirmation: false,
    };
  }

  onDelete = () => {
    if (this.props.item.id) {
      instance({
        url: `api/attributes/computed/${this.props.item.id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          // if (response.ok) {
          this.props.dispatch(
            notifySuccess(this.props.translate("computedAttributeIsDeleted"))
          );
          this.props.dispatch(
            removedComputedAttribute({ id: this.props.item.id })
          );
          this.props.closeCreateFrom();
          this.setState({ item: {} });
          // }
          // else{
          //   throw response
          // }
        })
        .catch((error) => {
          errorHandler(error, this.props.dispatch);
        });
    }
  };
  componentWillUnmount() {
    this.setState({
      onDeleteConfirmation: false,
    });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  onRemovedItem = () => {
    this.setState({
      onDeleteConfirmation: true,
    });
  };
  onCancel = () => {
    this.setState({
      onDeleteConfirmation: false,
    });
  };

  render() {
    return (
      <li className={"list-row clearfix"} key={this.props.item.id}>
        <label
          className="checkbox"
          onClick={(e) => this.props.editParameterForm(this.props.item)}
        >
          <span className="unit-name">
            <span className="unit-name-text">
              {this.props.item.description}
            </span>
          </span>
        </label>
        <div className="callout-actions">
          {checkPrivileges("attributeDelete") && (
            <span className="action" onClick={this.onRemovedItem}>
              <DeleteIcon className="material-icons" />
            </span>
          )}
        </div>

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.onDelete}
            title={this.props.translate("areYouWantToDelete")}
            children={this.props.item.description}
          />
        )}
      </li>
    );
  }
}

const mapState = (state) => ({
  themecolors: state.themeColors,
});

const mapStateToProps = connect(mapState);
export const ListRow = mapStateToProps(withTranslationWrapper(ListRow1));
export default mapStateToProps(Parameters);
